import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

export default function SocialCue({ type, text, isLighter }) {
  const theme = useContext(ThemeContext);

  return (
    <>
      <p
        className={classNames('social-cue', {
          'social-cue--assure': type === 'assure',
          'social-cue--assure-lighter': type === 'assure' && isLighter,
        })}
      >
        <FontAwesomeIcon
          icon={faCheck}
          style={{ marginRight: 8, marginTop: 2 }}
        />
        <span>{text}</span>
      </p>
      <style jsx>{`
        .social-cue {
          display: flex;
          margin-bottom: 4px;
          font-weight: bold;
        }
        .social-cue:last-child {
          margin-bottom: 0;
        }
        .social-cue--assure {
          color: ${theme.colors.socialcuecolor.assure};
        }
        .social-cue--assure-lighter {
          color: ${theme.colors.socialcuecolor.assurelighter};
        }
      `}</style>
    </>
  );
}

SocialCue.propTypes = {
  isLighter: PropTypes.bool,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['assure']).isRequired,
};

SocialCue.defaultProps = {
  isLighter: false,
};
